import {projectName} from "../../url";

export default function Footer() {
  return (
    <footer className="footer text-center">
      All Rights Reserved by {projectName}
    </footer>
  );
}
